import React from "react";
import FormComponent from "../Form/FormComponent";
import CloseIcon from "@material-ui/icons/Close";

export default props => {
  const renderContent = props => {
    return (
      <FormComponent
        editableData={props.editableData}
        formConfig={props.formConfig}
        formValidation={props.formValidation}
        modalClose={props.modalClose}
        params1={props.params1}
        params2={props.params2}
        params3={props.params3}
        params={props.params}
        query={props.query}
        query2={props.query2}
        onButton={props.onButton}
        getData={props.getData}
        editLinkedinData={props.editLinkedinData}
        updateData={props.updateData}
        customerid={props.customerid}
        buttonName={props.buttonName}
        className={props.className}
        message={props.message}
      />
    );
  };
  return (
    <div className={props.className}>
      <div>
        <div className="formHeader">
          <div
            style={{
              color: "#0456d9",
              fontSize: "18px",
              fontFamily: "inherit"
            }}
          >
            {props.title}
          </div>
          <div>
            <CloseIcon
              fontSize="small"
              onClick={props.modalClose}
              style={{ cursor: "pointer", color: "grey" }}
            />
          </div>
        </div>
      </div>
      {renderContent(props)}
    </div>
  );
};
